import styled from 'styled-components/macro';

import DropDownBase from '@components/common/core/Utils/DropDown';

export const DropDown = styled(DropDownBase)`
  & > div:first-child {
    border-bottom-color: ${({ theme }) => theme.colors.gray[6]};
  }

  & > div:last-child {
    padding: 24px;
    background-color: ${({ theme }) => theme.colors.gray[6]};

    @media only screen and (max-width: 388px) {
      padding: 12px;
      width: fit-content;
    }
  }
`;

export const DatePickerButton = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  transition: all 0.3s;
  display: flex;
  align-items: center;

  &:hover {
    filter: brightness(1.2);
    background-color: #1e222e;
    border-radius: 3px;
    padding: initial 6px;
  }

  svg {
    margin-left: 12px;
  }
`;

export const Container = styled.div``;
